import React from 'react';
import { checkTotalRateCalculation } from 'global/utils/election/subscriberValidation';
import { SUB_NAME_TEST_ID } from '../constants';
import { SubscriberInterestCardProps } from './types';
import {
  HeaderSectionStyled,
  IncompleteProfileErrorTagStyled,
  SubscriberCardStyled,
  SubscriberHeaderStyled,
  SubscriberNameLabelStyled,
} from './styles';
import TotalValidationTooltip from '../common/TotalValidationTooltip';
import SubscriberInterestCardList from './SubscriberInterestCardList';

const SubscriberInterestCard: React.FC<SubscriberInterestCardProps> = (props) => {
  const {
    subscriber,
    productLineIds,
    subscriberStatus,
    requiredSubInfo,
    className,
    isEditable = true,
    callbacksMap,
  } = props;

  const subscriberName = `${subscriber.common.firstName} ${subscriber.common.lastName}`;
  const totalRateCalculationResult = checkTotalRateCalculation({
    subscriber,
    electionFlow: 'quoting',
    requiredSubInfo,
  });

  const isIncompleteProfile = totalRateCalculationResult.errorTypes.includes('INCOMPLETE_PROFILE');

  return (
    <SubscriberCardStyled $isEditable={isEditable} className={className}>
      {isIncompleteProfile && (
        <IncompleteProfileErrorTagStyled isEditable={isEditable} isAddedToBatchSelection={false} />
      )}
      <SubscriberHeaderStyled $isIncompleteProfile={isIncompleteProfile}>
        <HeaderSectionStyled>
          <SubscriberNameLabelStyled data-test-id={SUB_NAME_TEST_ID}>{subscriberName}</SubscriberNameLabelStyled>
          {subscriberStatus}
        </HeaderSectionStyled>

        {totalRateCalculationResult.errorTypes.length > 0 && (
          <TotalValidationTooltip totalRateCalculationResult={totalRateCalculationResult} />
        )}
      </SubscriberHeaderStyled>

      <SubscriberInterestCardList
        subscriber={subscriber}
        productLineIds={productLineIds}
        requiredSubInfo={requiredSubInfo}
        isEditable={isEditable}
        callbacksMap={callbacksMap}
      />
    </SubscriberCardStyled>
  );
};

export default SubscriberInterestCard;
